<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="templateRoutingListHeaders"
    :request-func="getTemplateDocuments">
    <template #action-button>
      <v-btn @click="templateRoutingDocumentDialog('create')">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Створити маршрут
      </v-btn>
    </template>
    <template #item.name="{ item }">
      {{ item?.name || '---' }}
    </template>
    <template #item.documentType="{ item }">
      {{ item.documentType?.name || 'Не визначено' }}
    </template>
    <template #item.steps="{ item }">
      {{ item.steps?.length || 'Не визначено' }}
    </template>
    <template #item.employees="{ item }">
      {{ item.employees?.length || 'Не визначено' }}
    </template>
    <template #item.status="{ item }">
      <v-chip
        :color="item.statusId === 1 ? 'success' : 'error'"
        class="font-weight-bold"
        variant="tonal">
        <span class="font-weight-bold">{{
          item.statusId === 1 ? 'Активний' : 'Вимкнений'
        }}</span>
      </v-chip>
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Редагувати шаблон',
            action: () => templateRoutingDocumentDialog('update', item),
            icon: 'mdi-pencil',
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: 'Налаштувати маршрути',
            action: () => openRouteDialog(item),
            icon: 'mdi-pencil',
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: 'Видалити',
            action: () => templateRoutingDocumentDelete(item.id),
            icon: 'mdi-delete-forever',
            listItemProps: {
              class: 'text-error',
            },
            iconProps: {
              color: 'error',
            },
          },
        ]">
      </b-action-menu>
    </template>
  </b-server-table>
</template>
<script lang="ts">
import { ref } from 'vue'
import { axios } from '@/plugins'
import {
  urlDeleteTemplateRoutingDocument,
  urlGetTemplateRoutingDocuments,
} from '@/utils/urls'
import { navigateToItem } from '@/utils/helpers'
import { openDialog } from '@/dialog'
import { templateRoutingListHeaders } from '@/utils/tableHeaders'
import { BActionMenu, BServerTable } from 'best-modules/components/index'
import { Query } from 'best-modules/utils'

type TemplateRoutingDocument = {
  id: number
}

type TemplateRoutingDocumentAction = 'create' | 'update'

export default {
  name: 'TemplateRoutingDocumentList',
  components: { BActionMenu, BServerTable },
  data: () => {
    return {
      templateRoutingListHeaders,
    }
  },
  methods: { navigateToItem },
  setup() {
    const tableRenderKey = ref(1)

    const openRouteDialog = (item: TemplateRoutingDocument) => {
      openDialog({
        name: 'TemplateGroup',
        action: 'update',
        dialogData: { templateId: item.id, template: item },
      })
    }

    const getTemplateDocuments = (query: Query) => {
      return axios
        .get(urlGetTemplateRoutingDocuments({ ...query, paginate: true }))
        .then(res => {
          return res.data
        })
    }

    const templateRoutingDocumentDialog = (
      action: TemplateRoutingDocumentAction,
      item: TemplateRoutingDocument | Record<string, never> = {}
    ) => {
      openDialog({
        name: 'TemplateRoutingDocument',
        action: action === 'update' ? 'update' : 'create',
        params: {
          title: `${action === 'update' ? 'Редагування' : 'Створення'} шаблону`,
          submitLabel: `${action === 'update' ? 'Змінити' : 'Створити'}`,
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: {
          documentData: action === 'update' ? item : {},
          isUpdateTemplate: action === 'update',
        },
      })
    }
    const templateRoutingDocumentDelete = (id: number) => {
      return axios.delete(urlDeleteTemplateRoutingDocument(id)).then(res => {
        tableRenderKey.value += 1
        return res
      })
    }

    return {
      getTemplateDocuments,
      templateRoutingDocumentDialog,
      templateRoutingDocumentDelete,
      openRouteDialog,
      tableRenderKey,
    }
  },
}
</script>

<style lang="scss" scoped></style>
